export const fmtNum = (v: unknown, digits = 1) => (v === null || v === undefined || v === '' || Number.isNaN(Number(v)) ? '—' : Number(v).toLocaleString(undefined, { maximumFractionDigits: digits }));
export const fmtPct = (v: unknown) => (v === null || v === undefined ? '—' : `${fmtNum(v, 1)}%`);

export function fmtDate(v: unknown, opts: { time?: boolean } = { time: true }) {
  if (!v) return '—';
  const d = new Date(String(v));
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, opts.time ? { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' } : { year: 'numeric', month: 'short', day: '2-digit' });
}

export function relTime(v: unknown) {
  if (!v) return 'never';
  const t = new Date(String(v)).getTime();
  const s = Math.round((Date.now() - t) / 1000);
  const abs = Math.abs(s);
  const r = (n: number, u: string) => `${n} ${u}${n === 1 ? '' : 's'} ${s >= 0 ? 'ago' : 'from now'}`;
  if (abs < 60) return s >= 0 ? 'just now' : 'in a moment';
  if (abs < 3600) return r(Math.round(abs / 60), 'min');
  if (abs < 86400) return r(Math.round(abs / 3600), 'hour');
  if (abs < 30 * 86400) return r(Math.round(abs / 86400), 'day');
  return fmtDate(v, { time: false });
}

export const toLocalInput = (d: Date | string | null | undefined) => {
  if (!d) return '';
  const x = new Date(d);
  const off = x.getTimezoneOffset() * 60_000;
  return new Date(x.getTime() - off).toISOString().slice(0, 16);
};

export const cls = (...xs: Array<string | false | null | undefined>) => xs.filter(Boolean).join(' ');

/** Data volume in decimal units, as mobile operators quote bundles (1 MB = 1,000,000 bytes). */
export function fmtBytes(n: number | null | undefined) {
  if (n == null) return '';
  if (n < 1000) return `${Math.round(n)} B`;
  if (n < 1e6) return `${(n / 1e3).toFixed(n < 1e4 ? 1 : 0)} KB`;
  if (n < 1e9) return `${(n / 1e6).toFixed(n < 1e7 ? 2 : 1)} MB`;
  return `${(n / 1e9).toFixed(2)} GB`;
}
